import { api } from '../client/client.js';
import { formatDateTime } from '../format/format.js';

export function listPlans({ search, status, architecture } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (status && status !== 'all') params.set('status', status);
  if (architecture && architecture !== 'all') params.set('architecture', architecture);
  const qs = params.toString();
  return api.get(`/plans${qs ? `?${qs}` : ''}`).then((plans) => plans.map(mapPlan));
}

function mapPlan(p) {
  return {
    id: p.id,
    providerPlanId: p.provider_plan_id,
    name: p.name,
    description: p.description || '',
    descriptionEn: p.description_en || '',
    cpu: p.cpu,
    cpuType: p.cpu_type,
    ram: p.ram,
    storage: p.storage,
    architecture: p.architecture,
    price: Number(p.price) || 0,
    providerPrice: Number(p.provider_price) || 0,
    margin: Number(p.margin) || 0,
    marginPercent: p.margin_percent === null ? null : Number(p.margin_percent),
    marginLevel: p.margin_level,
    isActive: p.is_active,
    badge: p.badge || null,
    status: p.status,
    locationsAvailable: p.locations_available,
    lastSync: formatDateTime(p.last_sync),
    photos: p.photos || [],
  };
}

export function updatePlan(id, patch) {
  const body = {};
  if (patch.name !== undefined) body.name = patch.name;
  if (patch.description !== undefined) body.description = patch.description;
  if (patch.descriptionEn !== undefined) body.description_en = patch.descriptionEn;
  if (patch.price !== undefined) body.price = patch.price;
  if (patch.isActive !== undefined) body.is_active = patch.isActive;
  if (patch.badge !== undefined) body.badge = patch.badge;
  return api.put(`/plans/${id}`, body).then(mapPlan);
}

export function toggleVisibility(id) {
  return api.patch(`/plans/${id}/visibility`);
}

export function uploadPlanPhoto(id, photo, mime) {
  return api.post(`/plans/${id}/photo`, { photo, mime });
}

export function deletePlanPhoto(id, photoId) {
  return api.delete(`/plans/${id}/photo/${photoId}`);
}

export function syncNow() {
  return api.post('/plans/sync');
}
